import { LeftOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import LocalButton from './Button';

const Button = styled(LocalButton)`
    .ant-page-header-back & {
        margin-left: -0.9375rem;
    }
`;

const BackButton = props => <Button {...props} icon={<LeftOutlined />} />;

export default BackButton;
